import styled from 'styled-components';

export const Price = styled.div`
  display: flex;
  align-items: baseline;
  margin: 0.8rem 0;
  padding: 0;
  font-size: 0.8rem;
  p {
    margin: 0;
    span {
      font-weight: bold;
    }
  }
`;
export const PrevPrice = styled.h2`
  color: #979797;
  text-decoration: line-through;
  font-size: 1.2rem;
  margin: 0;
`;
export const DiscountedPrice = styled.h2`
  color: black;
  font-weight: bold;
  padding: 0rem 0.6rem;
  font-size: 1.7rem;
  margin: 0;
`;
